import { InfoCadastralPessoaJuridicaDTO, TipoContribuinte } from "src/app/sitfis/components/info-cadastrais-pj/model/info-cadastral-pj";

export const INFO_CADASTRAL_PESSOA_JURIDICA_DTO: InfoCadastralPessoaJuridicaDTO = {
  "tipoContribuinte": TipoContribuinte.CNPJMATRIZ,
  "cnpj": "02036483000614",
  "cnpjAdquirente": "",
  "codigoSituacaoCadastral": "02",
  "dataAbertura": new Date("1997-07-25"),
  "razaoSocial": "KXMVQMHMVWD NX OIWUQD FIXNGVXU WGVXPXVQEXU DVNW",
  "codigoBaixa": "00",
  "motivoBaixa": "",
  "dataBase": null,
  "situacaoCadastral": "ATIVA",
  "codigoPorteEmpresa": "05",
  "codigoQualificacaoTributaria": "",
  "inAcompanhamentoDiferenciado": "S",
  "anoAcompanhamentoDiferenciado": 2024,
  "anoInteresseDctf": [
    "0000",
    "0000",
    "0000",
    "0000",
    "0000"
  ],
  "inOpcaoSimplesNacional": "0",
  "inOpcaoSimplesFederal": "0",
  "inOpcaoSimei": "0",
  "codigoEnteFederativoResponsavel": "",
  "inFamiliaEnteFederativo": "0",
  "inCNPJAdquirente": 0,
  "unidade": {
    "codigo": 518000,
    "nome": "DERAT FEIRA DE SANTANA-BA"
  },
  "endereco": {
    "tipoLogradouro": "ROD",
    "logradouro": "OW 530  EQW KHVIHD  EQW WVDWMVQKW U/M KXMVQMHMVWD NX OIWU",
    "numero": "S/N",
    "complemento": "",
    "bairro": "POLO INDUSTRIAL DE CAMACARI",
    "cep": "42816901",
    "municipio": {
      "codigo": "3413",
      "nome": "CAMACARI",
      "uf": "BA"
    }
  },
  "responsavel": {
    "cpf": "85122220425",
    "nome": "HVITRL XZIOLH ILXSZ",
    "situacaoCadastral": "REGULAR",
    "qualificacao": "ADMINISTRADOR"
  },
  "preposto": {
    "cpf": "00000000000",
    "nome": ""
  },
  "naturezaJuridica": {
    "codigo": "206",
    "numeroDv": "2",
    "nome": "SOCIEDADE EMPRESARIA LIMITADA"
  },
  "atividadeEconomica": {
    "codigo": 2211100,
    "nome": "Fabricação de pneumáticos e de câmaras-de-ar"
  },
  "simplesSN": [],
  "simplesSF": [],
  "simplesSimei": []
}